import styled from "styled-components";

export const StyledMenu = styled.div`
.nav-item {
    font-family: Gelion;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    margin-right: 0px;
    padding: 0 10px;
  }
  
  .nav-item.wk {
    min-width: 140px;
  }
  
  .nav-item-active {
    filter: invert(25%) sepia(51%) saturate(3798%) hue-rotate(201deg) brightness(96%) contrast(94%);
  }
  
  .nav-item:hover {
    cursor: pointer;
  }
  
  .nav-icon {
    display: inline-block;
    line-height: 60px;
    margin-top: -3px;
    margin-right: 10px;
  }
  
  .nav-link {
    display: flex;
    align-items: center;
    justify-content:center
  }
  
  .nav-link>span {
    display: inline-block;
    height: 30px;
    line-height: 30px;
  }
  
  .nav-wrapper .logo {
    position: absolute;
    margin-left: 10px;
  }
  
  .left-block {
    margin-left: 130px;
    cursor: pointer;
  }
  
  .nav-icon svg {
    display: inline-block;
    line-height: 55px;
    margin-top: 0px;
    vertical-align: sub;
  }
  
  .menu {
    position: relative;
  }
  
  .dropdown {
    padding: 0;
    position: absolute;
    top: 100%;
    background-color: rgb(35, 41, 47);
    width: 230px;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s all ease-in-out;
    transform: translateY(20)
  }

  .isCompany {
    top: 120%;    
  }
  
  .dropdown.active {
    opacity: 1;
    visibility: visible;
    transition: 0.2s all ease-in-out;
    transform: translateY(0)
  }
  
  .dropdown ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .dropdown ul li {
    padding: 10px 15px;
    font-weight: 800;
  }
  
  .dropdown.active ul li:hover {
    background-color: #555;
  }
  
  .links {
    color: rgb(247, 250, 252) !important;
    text-decoration: none !important;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .links .desText {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #707070;
  }
  
  .links .icon {
    margin-right: 10px;
    margin-top: 5px;
  }
  
  .links:hover {
    text-decoration: none;
    color: rgb(247, 250, 252);
  }
  
  .links:active {
    text-decoration: none;
    color: rgb(247, 250, 252);
  }
  
  .dropdown-list {
    display: flex;
    flex-wrap: wrap;
  }
  
  .dropdown-list a {
    width: 100%;
    padding: 10px 12px;
    font-weight: 800;
    color: #f7fafc !important;
  }
  
  .dropdown-list a:hover {
    background-color: #555;
  }
  
  .df {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  
  .hover_elem:hover .hover_item {
    display: block;
    opacity: 1;
    transform: none;
    visibility: visible;
  }
  
  .itemlogo{
    margin-right: 10px;
    margin-top: 5px;
  }
`;


// WEBPACK FOOTER //
// ./src/pages/common/Menu/style.ts